import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

export const bancamigaService = {
  checkPayment: async (params) => {
    const response = await authInstance
      .get(
        `${url}/bancamiga/checkPayment?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  checkC2P: async (params) => {
    const response = await authInstance
      .post(`${url}/bancamiga/c2p?`, params)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  sypagoOtp: async (data) => {
    const response = await authInstance
      .post(`${url}/bancamiga/sypagoOtp`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
